import { render, staticRenderFns } from "./FleterosView.vue?vue&type=template&id=9a611ec2&"
import script from "./FleterosView.vue?vue&type=script&lang=ts&"
export * from "./FleterosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports